/* Components reconnect after native Shopify section rendering. */
if (!customElements.get('norgira-cart-shipping')) customElements.define('norgira-cart-shipping', class extends HTMLElement {
  connectedCallback() {
    const currency = this.dataset.currency || 'USD';
    const rate = currency === 'USD' ? 1 : Number(window.Shopify?.currency?.rate);
    if (!(rate > 0)) return; // Never compare another currency to a USD 100 threshold directly.
    const threshold = Math.round(10000 * rate);
    const total = Number(this.dataset.total);
    const remaining = Math.max(0, threshold - total);
    const message = this.querySelector('[data-shipping-message]');
    const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency }).format(remaining / 100);
    message.textContent = remaining ? `YOU ARE ${amount} AWAY FROM FREE WORLDWIDE SHIPPING` : 'FREE WORLDWIDE SHIPPING APPLIED TO YOUR ORDER';
    const percent = Math.min(100, Math.max(0, total / threshold * 100));
    const track = this.querySelector('[role="progressbar"]');
    track.setAttribute('aria-valuenow', Math.round(percent));
    track.firstElementChild.style.width = `${percent}%`;
  }
});
if (!customElements.get('norgira-cart-recommendations')) customElements.define('norgira-cart-recommendations', class extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.ncd-recommendations__track');
    window.NorgiraRandomRecommendations.populate(this);
    this.onScroll = () => this.updateButtons();
    this.onClick = event => {
      const button = event.target.closest('[data-direction]');
      if (!button) return;
      const card = this.track.querySelector('a');
      if (!card) return;
      const distance = (card.getBoundingClientRect().width + 5) * 2;
      this.track.scrollBy({left:distance * Number(button.dataset.direction),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    };
    this.addEventListener('click', this.onClick);
    this.track.addEventListener('scroll', this.onScroll, {passive:true});
    this.observer = new ResizeObserver(this.onScroll);
    this.observer.observe(this.track);
    this.updateButtons();
  }
  updateButtons() {
    this.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft < 2;
    this.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.track?.removeEventListener('scroll', this.onScroll);
    this.observer?.disconnect();
  }
});
